import React from 'react';
// import ReactDOM from 'react-dom';
import { hydrate, render } from "react-dom";
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/App.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

document.title = "Best Mobile & Web App Development Company New York - Complitech";

// Replaces default ReactDOM render by this for react-snap support
const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
  hydrate(<App />, rootElement);
} else {
  render(<App />, rootElement);
}

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
